// extracted by mini-css-extract-plugin
export default {"settings":"Zj6iNfe7g7oq8NgPxEz0","messagesWrapper":"I_vhhE0uoNG5qxB8WeDN"};